import React, { memo } from "react";
import BookNow from "components/BookNow/BookNow";
import Card from "components/Cards/Card";
import { useBusinessProfile } from "hooks/useFetch";

type Props = {
	id: number;
	title: string;
	address: string;
	phoneNumber: number;
	countryCode: string;
	formattedNumber: string;
};

const LocationCard = ({ title, id, address, phoneNumber, countryCode, formattedNumber }: Props) => {
	const { data: businessProfile } = useBusinessProfile();
	const widgetSetting = businessProfile?.data.widget;
	return (
		<Card>
			<div className="flex gap-4 items-center flex-col md:flex-row">
				<div className="w-full md:w-auto flex-auto">
					<h3 className="font-medium text-base mb-4">{title}</h3>
					{address && (
						<p className="font-base text-sm break-word">
							<a
								className="text-[#46474a] hover:text-zinc-800 hover:underline"
								href={`https://www.google.com/maps/?q=${address}`}
								target="_blank"
								rel="noreferrer"
							>
								{address}
							</a>
						</p>
					)}
					{phoneNumber && (
						<p className="font-base text-sm text-[#46474a] break-word mt-1">
							+{countryCode} {formattedNumber}
						</p>
					)}
				</div>
				<div className="w-full md:w-auto flex-none flex flex-col space-y-4 justify-end md:pl-4">
					<BookNow uniqueIdentifier={widgetSetting?.uniqueIdentifier} type="location" id={id} buttonWide />
				</div>
			</div>
		</Card>
	);
};

export default memo(LocationCard);
